import { FC, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { AccessibilityData } from "../../Typings/dataListing";
import { getAccessibilityById } from "../../redux/actions/accessibilityAction";
import { AppDispatch } from "../../redux/store";

const AccessibilityView: FC = () => {
  const { accessibilityid } = useParams<{ accessibilityid: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const [accessibilityData, setAccessibilityData] =
    useState<AccessibilityData | null>(null);
  const { permissions } = usePermissions();
  const roleid = localStorage.getItem("roleid") ?? "";

  useEffect(() => {
    getAccessibilityData();
  }, [dispatch, accessibilityid]);

  const getAccessibilityData = async () => {
    if (accessibilityid) {
      const payload = { accessibilityid: parseInt(accessibilityid, 10) };
      try {
        if (accessibilityid) {
          dispatch(
            getAccessibilityById(payload, (response: any) => {
              if (response?.status !== 500) {
                setAccessibilityData(response.data);
              }
            })
          );
        }
      } catch (error) {
        console.error("Error fetching community details:", error);
      }
    }
  };

  const formatBoolean = (value: boolean | undefined) => {
    return value ? "Yes" : "No";
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">F2F Accessibility</span>
              {accessibilityData?.market_name || "N/A"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Market Name
                <span className="d-block pt-1">
                  {accessibilityData?.market_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile Name
                <span className="d-block pt-1">
                  {accessibilityData?.profile_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile ID
                <span className="d-block pt-1">
                  {accessibilityData?.profile_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Bus Stop Nearby
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.bus_sub)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Bike Racks
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.bike_racks)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Sidewalks
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.sidewalks)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Free Parking
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.free_parking)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Roof Coverage
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.roof)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Access
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.other_access)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Access Explanation
                <span className="d-block pt-1">
                  {accessibilityData?.other_access_explain || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Selling Space
                <span className="d-block pt-1">
                  {accessibilityData?.selling_space || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Children Activities
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.children_activities)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Live Music
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.live_music)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Food Demonstrations
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.food_demonstrations)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Restrooms
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.restrooms)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Restroom Count
                <span className="d-block pt-1">
                  {accessibilityData?.restroom_count || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Accept SNAP
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.accept_snap)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                SNAP Offer
                <span className="d-block pt-1">
                  {accessibilityData?.snap_offer || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                FMNP Available
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.fmnp_available)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Accept FMNP
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.accept_fmnp)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                FMNP Offer
                <span className="d-block pt-1">
                  {accessibilityData?.fmnp_offer || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                FMNP Senior Available
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.fmnp_senior_available)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Accept FMNP Senior
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.accept_fmnp_senior)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                FMNP Senior Offer
                <span className="d-block pt-1">
                  {accessibilityData?.fmnp_senior_offer || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                CVV Available
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.cvv_available)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Accept CVV
                <span className="d-block pt-1">
                  {formatBoolean(accessibilityData?.accept_cvv)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                CVV Offer
                <span className="d-block pt-1">
                  {accessibilityData?.cvv_offer || "-"}
                </span>
              </li>
            </ul>

            <div className="pt-5 text-end">
              {permissions && roleid && (
                <NavLink to="/Accessibility">
                  <button type="button" className="formBtn cancel">
                    Back to List
                  </button>
                </NavLink>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default AccessibilityView;
